import React, { useState, useEffect, useRef } from 'react';
import { Header, Intro, About, Experience, Projects, Contact, Footer } from './components';
import ParticleBackground from './components/ParticleBackground';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import './styles.css';

function App() {
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') === 'light' ? 'light' : 'dark';
  });
  const bodyRef = useRef(null);
  
  useEffect(() => {
    // Shorter loading time for development
    const timer = setTimeout(() => {
      setLoading(false);
      console.log("Loading complete, rendering components");
    }, 1000); // reduced from 2500 to 1000ms
    
    // Apply theme to body
    if (theme === 'light') {
      document.body.classList.add('light-theme');
    } else {
      document.body.classList.remove('light-theme');
    }
    
    return () => clearTimeout(timer);
  }, [theme]);
  
  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };
  
  // Custom loader component
  const Loader = () => (
    <div className="loader-container">
      <div className="loader">
        <div className="loader-bar"></div>
      </div>
    </div>
  );
  
  useEffect(() => {
    const sections = document.querySelectorAll('.section');
    const navLinks = document.querySelectorAll('.nav-links a');
    
    const handleScroll = () => {
      let current = '';
      
      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        if (window.pageYOffset >= sectionTop - 150) {
          current = section.getAttribute('id');
        }
      });
      
      navLinks.forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('href') === `#${current}`) {
          link.classList.add('active');
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return (
    <div className="App" ref={bodyRef} style={{display: 'block', width: '100%', position: 'relative'}}>
      {console.log("Rendering App component")}
      <div className="background background-0"></div>
      <div className="background background-1"></div>
      
      <ParticleBackground />
      
      {loading ? (
        <Loader />
      ) : (
        <>
          {console.log("Rendering content")}
          <Header theme={theme} toggleTheme={toggleTheme} />
          
          <main className="content" style={{display: 'block', width: '100%', position: 'relative', zIndex: 10}}>
            {console.log("Rendering Intro")}
            <Intro />
            
            {console.log("Rendering About")}
            <About />
            
            {console.log("Rendering Experience")}
            <Experience />
            
            {console.log("Rendering Projects")}
            <Projects />
            
            {console.log("Rendering Contact")}
            <Contact />
            
            {console.log("Rendering Footer")}
            <Footer />
          </main>
          
          <ScrollToTop />
        </>
      )}
    </div>
  );
}

export default App;
